import ModelApplication from "@/module/insurance/models/ModelApplication";

class ModelStateApplication {
  loading = false;
  data = new ModelApplication();
}

export default ModelStateApplication;
